import cn from 'clsx'
import React, {type FC} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {ChartIcon} from '~/icons/home-page/chart-icon'
import SearchBoxRedesign from '~/components/search-combo/search-box-redesign'
import {getDomainConfig} from '~/domains'

const Header: FC = () => {
  const {locale, domain, language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: domainStyles} = getDomainConfig(domain, locale)

  return (
    <section className={cn(domainStyles.HOMEPAGE_HEADER_BG, domainStyles.HOMEPAGE_HEADER_TEXT, 'w-full')}>
      <div
        className={cn(
          domainStyles.UTILS_MAIN_CONTAINER,
          'mx-auto flex w-full flex-col gap-y-3 py-20 mobile:py-7',
          'homepage_header_bg homepage_header_text utils_main_container',
        )}
      >
        <span className="flex flex-row items-center gap-1.5 text-base font-semibold uppercase tracking-widest text-[#61C200] mobile:text-xs">
          <ChartIcon /> {translations.ImprovedHomePage.Header.upTitle}
        </span>
        <h1 className="text-5xl font-semibold leading-tight tracking-wide mobile:text-[34px] mobile:leading-[45px]">
          {translations.ImprovedHomePage.Header.title}
        </h1>
        <p className="text-2xl font-light leading-[24px] tracking-wide text-[#9C9C9C] mobile:text-[18px]">
          {translations.ImprovedHomePage.Header.subtitle}
        </p>
        <div className="mt-4 w-full desktop:max-w-80 mobile:mt-2">
          <SearchBoxRedesign standalone={true} />
        </div>
      </div>
    </section>
  )
}

export default Header
